import { Settings } from '@streamr/tv-engine';
import { EventEmitter } from 'eventemitter3';
import { WebAudioEncoderImpl } from './WebAudioEncoderImpl';
export class AudioProducer extends EventEmitter {
    webAudioEncoderImpl;
    currentAudioTimestampMicros = 0;
    audioDurationMicros = 0;
    constructor() {
        console.log('AudioProducer constructor');
        super();
        this.audioDurationMicros = Settings.audioFrameDurationMicroseconds;
    }
    async start(audioTrack) {
        console.log('Starting WebAudioEncoderImpl');
        await this.startWebAudioEncoder(audioTrack);
    }
    async stop() {
        if (this.webAudioEncoderImpl) {
            await this.stopWebAudioEncoder();
        }
        this.currentAudioTimestampMicros = 0;
    }
    onEncodedAudioData(audioData) {
        audioData.timestamp = BigInt(this.currentAudioTimestampMicros);
        audioData.duration = BigInt(this.audioDurationMicros);
        this.currentAudioTimestampMicros += this.audioDurationMicros;
        this.emit('audioData', audioData);
    }
    async startWebAudioEncoder(audioTrack) {
        this.webAudioEncoderImpl = new WebAudioEncoderImpl();
        this.webAudioEncoderImpl?.emitter.on('audioData', (audioData) => this.onEncodedAudioData(audioData));
        this.webAudioEncoderImpl?.emitter.on('audioVolume', (volume) => this.emit('audioVolume', volume));
        await this.webAudioEncoderImpl?.start(audioTrack);
    }
    async stopWebAudioEncoder() {
        if (this.webAudioEncoderImpl) {
            await this.webAudioEncoderImpl?.stop();
            this.webAudioEncoderImpl = undefined;
        }
    }
}
